
import { atom, selector } from "recoil";

export const ChatLogs = atom({
  key: "chatLogs",
  default: {
    users: [],
    totalCount: 0
  },
});

export const TotalUnreadCount = selector({
  key: "totalUnreadCount",
  get: ({ get }) => {
    const chatLogs = get(ChatLogs);
    return chatLogs.users.reduce((total, user) => total + (user.unreadCount || 0), 0);
  },
});

export const CurrentChat = atom({
  key: "currentChat",
  default: null,
});

export const MessageCenterState = atom({
  key: "messageCenterState",
  default: "Disconnected"
});